import React from "react";
import { registerOverlay } from "../overlays";
import { useLang } from "../i18n";
import { emphasise } from "../emphasis";

function FeatureStatement({ id, index, headline, emphasisWord, body }) {
  return (
    <div
      ref={(el) => registerOverlay(id, el)}
      data-testid={id}
      className="fixed inset-0 z-10 flex flex-col items-center justify-center px-6 text-center"
      style={{ willChange: "opacity, transform", opacity: 0 }}
    >
      <p className="ff-mono text-[11px] uppercase tracking-[0.2em] mb-5" style={{ color: "var(--bb-red)" }}>
        {`0${index} / 03`}
      </p>
      <h3 className="ff-head text-4xl sm:text-6xl lg:text-7xl leading-[1.04] tracking-[-0.02em] max-w-[16ch]" style={{ color: "var(--bb-ink)" }}>
        {emphasise(headline, emphasisWord)}
      </h3>
      <p className="mt-5 ff-serif text-[22px] sm:text-[26px] leading-[1.45] max-w-[34ch]" style={{ color: "var(--bb-ink-muted)" }}>
        {body}
      </p>
    </div>
  );
}

export default function ProductOverlay() {
  const { t } = useLang();
  const pr = t.product;
  return (
    <>
      {/* Persistent section label at top */}
      <div
        ref={(el) => registerOverlay("product-title", el)}
        className="fixed z-10 top-[13vh] left-0 right-0 text-center"
        style={{ willChange: "opacity, transform", opacity: 0 }}
      >
        <p className="ff-mono text-xs uppercase tracking-[0.2em]" style={{ color: "var(--bb-red)" }}>
          {pr.kicker}
        </p>
      </div>

      {pr.features.map((f, i) => (
        <FeatureStatement
          key={i}
          id={`feature-${i + 1}`}
          index={i + 1}
          headline={f.h}
          emphasisWord={f.em}
          body={f.b}
        />
      ))}
    </>
  );
}
